export enum HydroStressLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  VERY_HIGH = 'very_high',
  UNDEFINED = 'undefined',
}
